import React, { useState, useEffect } from 'react';
import { Warehouse } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import apiService from '../../services/apiService';

const SucursalFilter = ({ value, onChange, disabled }) => {
    const { isWebMode } = useApp();
    const [sucursales, setSucursales] = useState([]);

    useEffect(() => {
        if (!isWebMode) return;
        const cargar = async () => {
            try {
                const result = await apiService.getSucursalesDisponibles();
                if (result.success) {
                    setSucursales(result.data || []);
                }
            } catch (e) {
                // silencioso
            }
        };
        cargar();
    }, [isWebMode]);

    // Solo mostrar en modo web
    if (!isWebMode) return null;

    return (
        <div className="filter-group">
            <label className="filter-label">
                <Warehouse size={16} />
                Sucursal
            </label>
            <select
                className="filter-select"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
            >
                <option value="">Todas las sucursales</option>
                {sucursales.map(s => (
                    <option key={s} value={s}>{s}</option>
                ))}
            </select>
        </div>
    );
};

export default SucursalFilter;
